<form #form="ngForm">
    <h4>{{ 'time-off-v3.removalsEffectiveDate' | translate }}</h4>
    <!-- empty state -->
    <p *ngIf="removals.length === 0">{{ 'time-off-v3.noEmployeeRemovals' | translate }}</p>

    <ng-container *ngIf="removals.length > 0">
        <p>{{ 'time-off-v3.youveSelectedRemovalsNewEmployeesToRemove' | translate: { length: removals.length } }}</p>

        <div class="app-grid">
            <mat-form-field class="columns-3">
                <mat-label>{{ 'time-off-v3.accrualEndDate' | translate }}</mat-label>
                <input
                    [(ngModel)]="userSelectedDate"
                    name="accrualDatePicker"
                    #accrualDatePicker="ngModel"
                    required
                    [matDatepicker]="accrualEndDatePicker"
                    matInput
                    [min]="minDate"
                />
                <mat-datepicker-toggle matSuffix [for]="accrualEndDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #accrualEndDatePicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <h4 class="columns-4 margin-bottom-2">{{ 'time-off-v3.removedEmployees' | translate }}</h4>
        </div>

        <ng-container *ngFor="let employee of removals; let i = index">
            <div class="app-grid">
                <app-avatar class="columns-4" [employee]="employee" [name]="true"></app-avatar>
            </div>
        </ng-container>
    </ng-container>
</form>
